import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import React, { useEffect } from "react";
import {
  ApplicationSubtype,
  AppPageContentWrapper,
  CircularTextLoader,
  PageContentBox,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import { Alert, Box } from "@mui/material";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchRegprofAdditionalDocForm } from "../../../../store/redux/slice/Forms/regprofAdditionalDocForm";

const RegprofAdditionalDocEdit = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const regprofAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RegprofAdditionalDocForm;
  });

  useEffect(() => {
    dispatch(fetchRegprofAdditionalDocForm(id));
  }, [dispatch, id]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {regprofAdditionalDocForm.dataStateStatus === THUNK_STATUS.FULFILLED ? (
            <ServiceStepper
              serviceSteps={regprofAdditionalDocForm.steps}
              applicationSubtype={ApplicationSubtype.REGPROF_ADDITIONAL_DOCUMENTS}
            />
          ) : null}
          {regprofAdditionalDocForm.dataStateStatus === THUNK_STATUS.REJECTED ? (
            <Alert severity={"error"}>{t("m.generic.error.service.fail")}</Alert>
          ) : null}
          {regprofAdditionalDocForm.dataStateStatus === THUNK_STATUS.PENDING ? <CircularTextLoader /> : null}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};
export default RegprofAdditionalDocEdit;
